import { css } from "@styled-system/css";
import { AgencyNoticeType } from "~/apps/shared/constants/enums";

import { theme } from "@skin/v2";

import { AgencyNotice } from "../../models/agency-notice.model";

const colorsByAgencyNoticeType: Record<
  AgencyNoticeType,
  {
    background: string;
    color: string;
  }
> = {
  [AgencyNoticeType.CRITICAL]: {
    background: "#ffe2e5",
    color: theme.colors.pink[700],
  },
  [AgencyNoticeType.INFO]: {
    background: theme.colors.white,
    color: theme.colors.blue[700],
  },
  [AgencyNoticeType.SUCCESS]: {
    background: theme.colors.white,
    color: theme.colors.green[500],
  },
  [AgencyNoticeType.WARNING]: {
    background: "#fff3e7",
    color: "#e14e00",
  },
};

export const styles = {
  button: css({
    backgroundColor: "transparent",
    border: "none",
    color: "inherit",
    cursor: "pointer",
    flexShrink: 0,
    fontWeight: 600,
    textDecoration: "underline",
  }),
  content: {
    root: css({
      display: "inline",
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: "100%",
    }),
    text: (props: { isExpanded: boolean }) =>
      css({
        display: "inline",
        lineHeight: "1.25",
        overflow: "hidden",
        whiteSpace: props.isExpanded ? "normal" : "nowrap",
        width: "fit-content",
      }),
  },
  dismiss: css({
    alignItems: "center",
    backgroundColor: "transparent",
    border: "none",
    borderRadius: "4px",
    color: theme.colors.gray[300],
    cursor: "pointer",
    display: "flex",
    height: "24px",
    justifyContent: "center",
    margin: 0,
    padding: "4px",
    transition: "background-color 0.1s ease-in-out",
    width: "24px",
    "&:hover": {
      color: theme.colors.gray[700],
    },
  }),
  root: (props: { agencyNotice: AgencyNotice }) => {
    const { background, color } = colorsByAgencyNoticeType[
      props.agencyNotice.type
    ];

    return css({
      alignItems: "center",
      backgroundColor: background,
      borderBottom: `1px solid ${theme.colors.gray[100]}`,
      borderLeft: `12px solid ${color}`,
      color,
      display: "flex",
      fontSize: "0.875rem",
      fontWeight: "500",
      gap: "12px",
      padding: "16px",
      "& svg": {
        strokeWidth: "2px",
      },
    });
  },
};
